import { cva, type VariantProps } from "class-variance-authority";

/**
 * Variantes de estilo para o componente Badge.
 * As chaves devem corresponder aos tipos de variante.
 */
export const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

/**
 * Props de variante para o Badge, inferidas de badgeVariants.
 */
export type BadgeVariantProps = VariantProps<typeof badgeVariants>; 